import styled from "@emotion/styled";
import React from "react";
import { default as WrapperGiftIcon } from "/public/assets/wrapped-gift.svg?react";

interface Props {
  points: number;
  onClick: () => void;
}

const CaregiverPointsBadge = (props: Props) => {
  return (
    <Wrapper>
      <Root onClick={props.onClick}>
        <WrapperGiftIcon width="14" height="14" />
        <Points>{formatNumber(props.points)}</Points>
      </Root>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline-block;
`;

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 0 8px;
  border-radius: 8px;
  border: 1px solid var(--gray-100);
  box-sizing: border-box;
  height: 24px;
`;

const Points = styled.span`
  font-size: 14px;
  font-weight: 700;
`;

function formatNumber(number: number) {
  if (number < 1000) {
    return number;
  }

  if (number < 1000000) {
    return `${Math.round(number / 1000)}K`;
  }

  return `${Math.round(number / 1000000)}M`;
}

export default CaregiverPointsBadge;
